import { LitElement, html, css } from 'lit-element';

// These are the shared styles needed by this element.
import { htPandoraEditableStyles } from './styles/ht-pandora-editable-styles';
import { ROUTES } from '../constants/routes';
import { UPDATE_WARNINGS } from '../constants/updateWarnings';
import { LINKS } from '../constants/links';
import { OPTIONS } from '../constants/options';
import { config } from '../functions/config';
import { postDataFactory } from '../functions/postDataFactory';
import { createNotificationObj } from '../functions/notificationFactory';
import { changePage } from '../functions/changePage';
import { getFieldSectionLinks } from '../functions/fieldSectionLink';

import './htPandoraFormWrapper';

class htPandoraEditableRenewalGC extends LitElement {
    static get properties() {
        return {
            renewal: { type: Object },
            fields: { type: Array },
            _complete: { type: Boolean }
        };
    }

    constructor() {
        super();
        this.postData = postDataFactory({ fetch: window.fetch, apiEndPoint: `${config.renewalAPI}` });
        this._complete = false;
        this.fields = [];
    }

    _submitContractEdit() {
        const formData = JSON.parse(this.shadowRoot.querySelector('ht-pandora-form-wrapper').getAttribute('formdata'));
        formData.id = this.renewal.id;

        formData.status = OPTIONS.RENEWAL_STATUS.PENDING;

        const confirmEmail = confirm(`Do you want to automatically send an email with the update to the customer?`);
        if(confirmEmail) {
            formData.sendEmail = true;
        }

        const sendUpdate = new CustomEvent('send-update', {
            detail: {
                changes: formData,
                table: 'renewal',
                post: this.postData,
                element: this
            }
        });
        this.dispatchEvent(sendUpdate);
    }

    _formCompleteToggle(e) {
        this._complete = e.detail.complete;
    }

    shouldUpdate() {
        if(this.renewal !== null) return true;
        return false;
    }

    _cancelEdits() {
        this.shadowRoot.querySelector('ht-pandora-form-wrapper').setAttribute('formdata', '{}');
    }

    _close() {
        const closeEdit = new CustomEvent('close-edit', {
            detail: {
                element: this
            }
        });
        this.dispatchEvent(closeEdit);
    }

    static get styles() {
        return css`${htPandoraEditableStyles}`;
    }

    render() {
        return html`
            <div class="form-section-title">
                <h2>Updating Renewal GC Details</h2>
            </div>
            <p class="info">The status will automatically be set to "Pending"</p>
            <form @submit="${e => e.preventDefault()}">
                <ht-pandora-form-wrapper
                    @form-complete="${this._formCompleteToggle}"
                    @form-data="${this._formDataUpdated}"
                    fields="${JSON.stringify(this.fields)}"
                    item="${JSON.stringify(this.renewal)}"
                ></ht-pandora-form-wrapper>
                <div class="buttons">
                    <button class="ht-button ht-button-secondary" type="button" @click="${() => this._close()}">Back</button>
                    <button ?disabled="${!this._complete}" class="ht-button" type="button" @click="${() => this._submitContractEdit()}">Submit</button>
                </div>
            </form>
        `;
    }
}

window.customElements.define('ht-pandora-editable-renewal-gc', htPandoraEditableRenewalGC);
